"use client";

function localStorageAdapter<T>(key: string) {
  return {
    get: (): T | undefined => {
      const value = localStorage.getItem(key);
      return value && value !== "undefined" ? JSON.parse(value) : undefined;
    },
    set: (value: T): void => {
      localStorage.setItem(key, JSON.stringify(value));
    },
    remove: (): void => {
      localStorage.removeItem(key);
    },
  };
}

export namespace LS {
  export type Service = {
    get:    <T>(key: string)           => T | undefined;
    set:    <T>(key: string, value: T) => void;
    remove:    (key: string)           => void;
  };
}

export function persistentDictionary(): LS.Service {
  return {
    get:    <T>(key: string): T |  undefined => localStorageAdapter<T>   (key).get(),
    set:    <T>(key: string, value: T): void => localStorageAdapter<T>   (key).set(value),
    remove:    (key: string): void           => localStorageAdapter<void>(key).remove(),
  };
}
